
import React, {useEffect, useContext, useRef} from "react";
import classnames from "classnames";
// reactstrap components
import {
    Input,
    Row,
    Col,
    CardHeader,Card, CardBody, Button, FormGroup
} from "reactstrap";

import {
    Image
} from "react-bootstrap";

import { UserLoginContext } from "../../context/UserLoginContext";
import { CollectionsContext } from "../../context/CollectionsContext";
import {useHistory, useParams, useLocation} from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import NotificationAlert from "react-notification-alert";
import rest from "../../API/api";
import { authenticatedFetch } from "../../services/authService";

const AddTourneyImage = () => {
    const { collectionId } = useParams();
    const routerLocation = useLocation();
    const searchParams = new URLSearchParams(routerLocation.search);
    const from = searchParams.get('from');
    const imageMimeType = /image\/(png|jpg|jpeg)/i;
    const hiddenFileInput = useRef(null);

    // eslint-disable-next-line
    const [collectionsState, setCollectionsState] = useContext(CollectionsContext);
    const [userState, setUserState] = useContext(UserLoginContext);
    const [title, settitle] = React.useState("");
    const [titleState, settitleState] = React.useState("");
    const [titleFocus, settitleFocus] = React.useState("");
    // eslint-disable-next-line
    const [description, setdescription] = React.useState("");
    const [descriptionState, setdescriptionState] = React.useState("");
    const [descriptionFocus, setdescriptionFocus] = React.useState("");

    const [location, setlocation] = React.useState("");
    const [locationState, setlocationState] = React.useState("");
    const [locationFocus, setlocationFocus] = React.useState("");

    const [caption, setcaption] = React.useState("");
    const [captionState, setcaptionState] = React.useState("");
    const [captionFocus, setcaptionFocus] = React.useState("");

    const [value, setvalue] = React.useState("");
    const [valueState, setvalueState] = React.useState("");
    const [valueFocus, setvalueFocus] = React.useState("");

    const [image, setimage] = React.useState("");
    const [imageState, setimageState] = React.useState("");
    const [imageFocus, setimageFocus] = React.useState("");

    const [imagePreviewUrl, setimagePreviewUrl] = React.useState("");
    const [imagePreviewUrlState, setimagePreviewUrlState] = React.useState("");
    const [imagePreviewUrlFocus, setImagePreviewUrlFocus] = React.useState("");

    const [alert, setalert] = React.useState(null);
    const notificationAlertRef = useRef(null);
    const history = useHistory();

    const notify = (type, message) => {
        const options = {
            place: "tc",
            message: <div>{message}</div>,
            type: type,
            icon: "tim-icons icon-bell-55",
            autoDismiss: 5,
        };
        notificationAlertRef.current.notificationAlert(options);
    };

    const stateFunctions = {
        settitleState: (value) => settitleState(value),
        settitle: (value) => settitle(value),
        setdescriptionState: (value) => setdescriptionState(value),
        setdescription: (value) => setdescription(value),
        setlocationState: (value) => setlocationState(value),
        setlocation: (value) => setlocation(value),
        setcaptionState: (value) => setcaptionState(value),
        setcaption: (value) => setcaption(value),
        setvalueState: (value) => setvalueState(value),
        setvalue: (value) => setvalue(value),
        setimageState: (value) => setimageState(value),
        setimage: (value) => setimage(value),
        setimagePreviewUrlState: (value) => setimagePreviewUrlState(value),
        setimagePreviewUrl: (value) => setimagePreviewUrl(value),
    };

    // function that verifies if a string has a given length or not
    const verifyLength = (value, length) => {
        if (value.length >= length) {
            return true;
        }
        return false;
    };
    // function that verifies if value contains only numbers
    const verifyNumber = (value) => {
        var numberRex = new RegExp("^[0-9]+$");
        if (numberRex.test(value)) {
            return true;
        }
        return false;

    };
    const change = (event, stateName, type, stateNameEqualTo, maxValue) => {
        switch (type) {
            case "length":
                if (verifyLength(event.target.value, stateNameEqualTo)) {
                    stateFunctions["set" + stateName + "State"]("has-success");
                } else {
                    stateFunctions["set" + stateName + "State"]("has-danger");
                }
                stateFunctions["set" + stateName](event.target.value);
                break;
            case "number":
                if (verifyNumber(event.target.value, stateNameEqualTo)) {
                    stateFunctions["set" + stateName + "State"]("has-success");
                } else {
                    stateFunctions["set" + stateName + "State"]("has-danger");
                }
                stateFunctions["set" + stateName](event.target.value);
                break;
            default:
                break;
        }

    };
    /*eslint-disable-next-line*/
    const isValidated = () => {
        if (
            titleState === "has-success" &&
            descriptionState === "has-success" &&
            locationState === "has-success" &&
            captionState === "has-success" &&
            valueState === "has-success" &&
            imagePreviewUrlState === "has-success"
        ) {
            return true;
        } else {
            if (titleState !== "has-success") {
                settitleState("has-danger");
            }
            if (descriptionState !== "has-success") {
                setdescriptionState("has-danger");
            }
            if (locationState !== "has-success") {
                setlocationState("has-danger");
            }
            if (captionState !== "has-success") {
                setcaptionState("has-danger");
            }
            if (valueState !== "has-success") {
                setvalueState("has-danger");
            }
            if (imagePreviewUrlState !== "has-success") {
                setimagePreviewUrlState("has-danger");
            }
            //Need to add something here for the Image verification...

            return false;
        }
    };

    const _addImageAlert = async () => {
        //console.log("email to delete:" + email);
        //debugger;
        setalert(
            <SweetAlert
                warning
                showCancel
                confirmBtnText="Yes, save it!"
                confirmBtnBsStyle="info"
                cancelBtnBsStyle="default"
                title="Are you sure?"
                style={{display: "block"}}
                onConfirm={() => {
                    _add_image("tourney");
                    setalert(null);
                }}
                onCancel={() =>  {
                    setalert(null);
                }}
            >
                Are you sure you want to save this image?
            </SweetAlert>
        );
    };

    const handleClick = event => {
        hiddenFileInput.current.click();
    };

    const changeHandler = (e) => {
        const file = e.target.files[0];
        //console.log(imagePreviewUrl);
        if(!file){
            //setimagePreviewUrlState("has-danger");
            return;
        }
        else if (!file.type.match(imageMimeType)) {
            setimagePreviewUrlState("has-danger");
            return;
        }
        setimagePreviewUrlState("has-success");
        setimage(file);

    };

    useEffect(() => {
        let fileReader, isCancel = false;
        if (image) {
            fileReader = new FileReader();
            fileReader.onload = (e) => {
                const { result } = e.target;
                if (result && !isCancel) {
                    setimagePreviewUrl(result);
                }
            };
            fileReader.readAsDataURL(image);
            /*
            console.log("FILE...");
            console.log(image);
            console.log("URL...");
            console.log(imagePreviewUrl);
            */
        }
        return () => {
            isCancel = true;
            if (fileReader && fileReader.readyState === 1) {
                fileReader.abort();
            }
        };

    }, [image]);


    const _add_image = async (mode) => {
        // Backend now handles Cloudinary upload - just send base64 image
        const imageFile = imagePreviewUrl;

        if (!imageFile) {
            notify("danger", "Please select an image.");
            return;
        }

        let tempURL = "";
        switch(mode) {
            case "cohort":
                tempURL = rest.cohortImages + '/' + collectionId;
                break;
            case "tourney":
                tempURL = rest.tourneyImages + '/' + collectionId;
                break;
            case "general":
                tempURL = rest.generalImages + '/' + collectionId;
                break;
            default:
                break;
        }

        try {
            // Send image and metadata to backend - backend handles Cloudinary upload
            const addImageResponse = await authenticatedFetch(tempURL, {
                method: 'POST',
                body: JSON.stringify({
                    Title: title,
                    Description: description,
                    Location: location,
                    Caption: caption,
                    Value: value,
                    Image: imageFile  // Backend expects base64 image
                })
            });

            if (!addImageResponse.ok) {
                const errorData = await addImageResponse.json();
                throw new Error(errorData.message || 'Failed to add image');
            }

            const addImageJSON = await addImageResponse.json();
            console.log('Image added successfully:', addImageJSON);

            // Reload the collections context with updated images
            let collectionURL = rest.tourneyImages + '/' + collectionId;
            const tourneyImagesList = await authenticatedFetch(collectionURL, {
                method: 'GET'
            });
            const tourneyImagesData = await tourneyImagesList.json();
            setCollectionsState((prevcollectionsState) => ({
                ...prevcollectionsState,
                tourneyImages: tourneyImagesData
            }));

            notify("success", "Image has been added successfully!");

            // Navigate back to images table after a short delay
            setTimeout(() => {
                let tURL = "/admin/edittourneyimages/" + collectionId;
                history.push(tURL);
            }, 1000);
        } catch (error) {
            console.error('Error adding image:', error);
            notify("danger", error.message || 'Failed to add image.');
        }
    };

    if (userState.status) {
      return (
          <>
              <div className="rna-container">
                  <NotificationAlert ref={notificationAlertRef} />
              </div>
              <div className="content">
                  <Col md={8} className="ml-auto mr-auto">
                      <h2 className="text-center">Add a Tourney Collection Image</h2>
                      <p className="text-center">
                          Collection Name: {collectionsState.tourneyCollection.Title}
                      </p>
                  </Col>


                  <Card>
                      <CardHeader>Image Information:</CardHeader>
                      <CardBody>
                          <Row>
                              <Col md={5} mdOffset={1}>
                                  <FormGroup className={`has-label ${titleState}`}>
                                      <label>Image Title *</label>
                                      <Input
                                          name="title"
                                          type="text"
                                          value={title}
                                          onChange={(e) => change(e, "title", "length",1)}
                                      />
                                      {titleState === "has-danger" ? (
                                          <label className="error">
                                              Please enter a valid image title.
                                          </label>
                                      ) : null}
                                  </FormGroup>
                              </Col>
                              <Col md={3} mdOffset={1}>
                                  <FormGroup className={`has-label ${descriptionState}`}>
                                      <label>Image Description *</label>
                                      <Input
                                          name="description"
                                          type="text"
                                          value={description}
                                          onChange={(e) => change(e, "description", "length",1)}
                                      />
                                      {descriptionState === "has-danger" ? (
                                          <label className="error">
                                              Please enter a valid description.
                                          </label>
                                      ) : null}
                                  </FormGroup>
                              </Col>
                          </Row>
                          <Row>
                              <Col md={5} mdOffset={1}>
                                  <FormGroup className={`has-label ${locationState}`}>
                                      <label>Location *</label>
                                      <Input
                                          name="location"
                                          type="text"
                                          value={location}
                                          onChange={(e) => change(e, "location", "length",1)}
                                      />
                                      {locationState === "has-danger" ? (
                                          <label className="error">
                                              Please enter a valid image location.
                                          </label>
                                      ) : null}
                                  </FormGroup>
                              </Col>
                              <Col md={3} mdOffset={1}>
                                  <FormGroup className={`has-label ${captionState}`}>
                                      <label>Caption *</label>
                                      <Input
                                          name="caption"
                                          type="text"
                                          value={caption}
                                          onChange={(e) => change(e, "caption", "length",1)}
                                      />
                                      {captionState === "has-danger" ? (
                                          <label className="error">
                                              Please enter a valid caption.
                                          </label>
                                      ) : null}
                                  </FormGroup>
                              </Col>
                              <Col md={3} mdOffset={1}>
                                  <FormGroup className={`has-label ${valueState}`}>
                                      <label>Value *</label>
                                      <Input
                                          name="value"
                                          type="text"
                                          value={value}
                                          onChange={(e) => change(e, "value", "length",1)}
                                      />
                                      {valueState === "has-danger" ? (
                                          <label className="error">
                                              Please enter a valid value.
                                          </label>
                                      ) : null}
                                  </FormGroup>
                              </Col>
                          </Row>
                          <Row>
                              <Col md={1} mdOffset={1} xs={1} xsOffset={1}>
                                  <FormGroup className={`has-label ${imageState}`}>
                                      <label>Image *</label>
                                      <Input style={{display: 'none'}}
                                             name="value"
                                             type="text"
                                             value={value}
                                             onChange={(e) => change(e, "value", "length", 1)}
                                      />

                                      <Button type="button" bsStyle="info" onClick={handleClick} fill>
                                          Pick an Image
                                      </Button>
                                      <input style={{display: 'none'}}
                                             type="file"
                                             onChange={changeHandler}
                                             ref={hiddenFileInput}
                                             id="image"
                                             name="image"
                                             accept='.png, .jpg, .jpeg'

                                      />

                                  </FormGroup>
                              </Col>
                          </Row>
                          <Row>
                              <Col md={3} mdOffset={1}>
                                  {(imagePreviewUrlState === "has-danger") ? (
                                              <med className="text-danger">
                                                  Please select a valid image file.
                                              </med>
                                          ) : (null)
                                  }
                                  {imagePreviewUrl ? (
                                      <FormGroup className={`has-label ${imagePreviewUrlState}`}>
                                          <label>Preview:</label>
                                          <Image src={imagePreviewUrl} alt="preview" responsive/>
                                      </FormGroup>) :(null)
                                  }
                              </Col>
                          </Row>
                      </CardBody>
                  </Card>
                  <Card>
                  <CardBody>
                          <Row>
                              <Col md={1} mdOffset={1} xs={5} xsOffset={1}>
                                  <Button type="button" color="info" className="animation-on-hover" onClick={ async () => {
                                      if(isValidated()) {
                                          await _addImageAlert();
                                      }
                                  }}>Save
                                  </Button>
                              </Col>
                              <Col md={1} mdOffset={1} xs={5} xsOffset={1}>
                                  <Button type="button" color="danger" className="animation-on-hover" onClick={ async () => {
                                          let tURL = from === 'collections'
                                              ? "/admin/tourneycollections"
                                              : "/admin/edittourneyimages/" + collectionId;
                                          await history.push(tURL);
                                  }}>Cancel
                                  </Button>
                              </Col>
                          </Row>
                      </CardBody>
                  </Card>
                  {alert}
              </div>
          </>
      );
    }
    else {
        //alert("You must be logged in and have an active subscription to access this page!");
        history.push("/admin/dashboard");
        return(null);
    }
};
export default AddTourneyImage;
